import { Group, Image } from "@mantine/core";
import reviewBanner from "/assets/images/reviews/comments_six.png";

const ReviewsSection = () => {
    return (
        <Group justify="center" align="center" w="100%">
            <Image src={reviewBanner} alt="review" w="100%" />
        </Group>
    )
}

export default ReviewsSection;